import { Flex, Text, Box } from "@chakra-ui/react";

import { TextSecondary, InfoCardBody, IconBackgroundContainer } from "theme";

import InfoCard from "@components/InfoCard";
import Icon from "@components/Icon";

import { PlatformItems } from "@customtypes/common";
import Disclaimer from "@components/Disclaimer";

interface PlatformCardProps {
  title?: string;
  platformData: PlatformItems[];
}

const PlatformCard = ({ title, platformData }: PlatformCardProps) => {
  return (
    <InfoCard title={title}>
      <InfoCardBody>
        <>
          {platformData.map((platform, index) => (
            <Flex
              key={platform.title}
              mt={index > 0 ? "1rem" : 0}
              mb={4}
              alignItems="center"
            >
              <IconBackgroundContainer
                display={{ base: "none", xl: "inherit" }}
              >
                <Box
                  w={{ base: "16px", lg: "24px" }}
                  h={{ base: "16px", lg: "24px" }}
                >
                  {platform.icon && (
                    <Icon
                      width="100%"
                      height="100%"
                      color="textSecondary"
                      Icon={platform.icon}
                    />
                  )}
                </Box>
              </IconBackgroundContainer>
              <Flex
                ml={{ base: "0px", xl: "1rem" }}
                flexDirection={{ base: "row-reverse", xl: "column" }}
                fontSize={{ base: "12px", xl: "14px" }}
                fontWeight="600"
                justifyContent={{ base: "space-between", xl: "center" }}
                flex={1}
                lineHeight="20px"
              >
                <Text>{platform.value}</Text>
                <TextSecondary
                  fontSize="12px"
                  fontWeight="400"
                  lineHeight="18px"
                >
                  {platform.title}
                </TextSecondary>
              </Flex>
            </Flex>
          ))}
          <Disclaimer />
        </>
      </InfoCardBody>
    </InfoCard>
  );
};

export default PlatformCard;
